<div class="d-flex min-vh-100 flex-column">
  <app-header></app-header>
  <div class="flex-fill d-flex flex-column justify-content-center">
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</div>
